import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Context/AppContext';
import { getAuthenticatedHomePath } from '../../Shared/homePath';
import Hero from './Hero';
import LandingHead from './LandingHead';
import LandingNav from './LandingNav';
import SampleDemo from './SampleDemo';
import ProductPreview from './ProductPreview';
import FollowUps from './FollowUps';
import Features from './Features';
import HowItWorks from './HowItWorks';
import PricingSection from './Pricing';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Footer from './Footer';
import { scrollToSection } from './constants';

const Landing = ({ toggleDarkMode, darkMode }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const { state } = useAppContext();
	const sectionHash = (location.hash || '').replace(/^#/, '');

	useEffect(() => {
		// Allow signed-in users to open marketing sections (e.g. /#testimonials from Settings).
		if (state.isAuthenticated && !sectionHash) {
			navigate(getAuthenticatedHomePath(state.user));
		}
	}, [navigate, state.isAuthenticated, state.user, sectionHash]);

	useEffect(() => {
		if (!sectionHash) {
			return;
		}
		const timer = window.setTimeout(() => {
			scrollToSection(sectionHash);
		}, 50);
		return () => window.clearTimeout(timer);
	}, [sectionHash]);

	return (
		<Box sx={{ backgroundColor: 'background.default' }}>
			<LandingHead />
			<LandingNav toggleDarkMode={toggleDarkMode} darkMode={darkMode} />
			<Hero />
			<SampleDemo />
			<ProductPreview />
			<FollowUps />
			<Features />
			<HowItWorks />
			<PricingSection />
			<Testimonials />
			<FAQ />
			<Footer />
		</Box>
	);
};

export default Landing;
